import { render, staticRenderFns } from "./table_header.vue?vue&type=template&id=abf887ac&scoped=true"
import script from "./table_header.vue?vue&type=script&lang=js"
export * from "./table_header.vue?vue&type=script&lang=js"
import style0 from "./table_header.vue?vue&type=style&index=0&id=abf887ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf887ac",
  null
  
)

export default component.exports